module.exports = __webpack_public_path__ + "static/media/facebook.96d74e1e.svg";